export const getFromLocalStorage = (storageName: string, defaultValue: any) => {
  try {
    const item = localStorage.getItem(storageName)

    return item
      ? {
        ...defaultValue,
        ...JSON.parse(item)
      }
      : defaultValue
  } catch (error) {
    return defaultValue
  }
}

export const getFromLocalStorageDefValues = <T extends object>(storageName: string, defaultValue: T) => {
  try {
    const item = localStorage.getItem(storageName)
    const localStorageValues = item ? JSON.parse(item) : {}

    return Object.keys(defaultValue).reduce(
      (acc, cur) =>
        localStorageValues[cur]
          ? {
            ...acc,
            [cur]: localStorageValues[cur]
          }
          : acc,
      defaultValue
    )
  } catch (error) {
    return defaultValue
  }
}
